
export const Colors = [
   "Abbey",
   "Absolute Zero",
   "Acadia",
   "Acapulco",
   "Acid Green",
   "Aero",
   "Aero Blue",
   "Affair",
   "African Violet",
   "Air Force Blue",
   "Air Superiority Blue",
   "Akaroa",
   "Alabama Crimson",
   "Alabaster",
   "Albescent White",
   "Algae Green",
   "Alice Blue",
   "Alien Armpit",
   "Alizarin Crimson",
   "Alloy Orange",
   "Allports",
   "Almond",
   "Almond Frost",
   "Alpine",
   "Alto",
   "Aluminium",
   "Amaranth",
   "Amaranth Pink",
   "Amaranth Purple",
   "Amaranth Red",
   "Amazon",
   "Amber",
   "American Rose",
   "Americano",
   "Amethyst",
   "Amethyst Smoke",
   "Amour",
   "Amulet",
   "Anakiwa",
   "Android Green",
   "Anti Flash White",
   "Antique Brass",
   "Antique Bronze",
   "Antique Fuchsia",
   "Antique Ruby",
   "Antique White",
   "Anzac",
   "Ao",
   "Apache",
   "Apple",
   "Apple Blossom",
   "Apple Green",
   "Apricot",
   "Apricot White",
   "Aqua Deep",
   "Aqua Forest",
   "Aqua Haze",
   "Aqua Island",
   "Aqua Spring",
   "Aqua Squeeze",
   "Aquamarine",
   "Aquamarine Blue",
   "Arapawa",
   "Arctic Lime",
   "Armadillo",
   "Army Green",
   "Arrowtown",
   "Arsenic",
   "Artichoke",
   "Arylide Yellow",
   "Ash",
   "Ash Grey",
   "Asparagus",
   "Asphalt",
   "Astra",
   "Astral",
   "Astronaut",
   "Astronaut Blue",
   "Athens Gray",
   "Aths Special",
   "Atlantis",
   "Atoll",
   "Au Chico",
   "Aubergine",
   "Auburn",
   "Aureolin",
   "Auro Metal Saurus",
   "Australian Mint",
   "Avocado",
   "Axolotl",
   "Azalea",
   "Aztec",
   "Aztec Gold",
   "Azure",
   "Azure Mist",
   "Azureish White",
   "Baby Blue",
   "Baby Blue Eyes",
   "Baby Powder",
   "Bahama Blue",
   "Bahia",
   "Baja White",
   "Baker Miller Pink",
   "Bali Hai",
   "Ball Blue",
   "Baltic Sea",
   "Bamboo",
   "Banana Mania",
   "Banana Yellow",
   "Bandicoot",
   "Barberry",
   "Barbie Pink",
   "Barley Corn",
   "Barley White",
   "Barn Red",
   "Barossa",
   "Bastille",
   "Battleship Gray",
   "Bay Leaf",
   "Bay of Many",
   "Bazaar",
   "Bdazzled Blue",
   "Beau Blue",
   "Beauty Bush",
   "Beaver",
   "Beeswax",
   "Beige",
   "Belgion",
   "Bermuda",
   "Bermuda Gray",
   "Beryl Green",
   "Bianca",
   "Big Dip Oruby",
   "Big Foot Feet",
   "Big Stone",
   "Bilbao",
   "Biloba Flower",
   "Birch",
   "Bird Flower",
   "Biscay",
   "Bismark",
   "Bison Hide",
   "Bisque",
   "Bistre",
   "Bitter",
   "Bitter Lemon",
   "Bittersweet",
   "Bittersweet Shimmer",
   "Bizarre",
   "Black",
   "Black Bean",
   "Black Coral",
   "Black Forest",
   "Black Haze",
   "Black Leather Jacket",
   "Black Marlin",
   "Black Olive",
   "Black Pearl",
   "Black Rock",
   "Black Rose",
   "Black Russian",
   "Black Shadows",
   "Black Squeeze",
   "Black White",
   "Blackberry",
   "Blackcurrant",
   "Blanched Almond",
   "Blast Off Bronze",
   "Blaze Orange",
   "Bleach White",
   "Bleached Cedar",
   "Bleu De France",
   "Blizzard Blue",
   "Blond",
   "Blossom",
   "Blue",
   "Blue Bayoux",
   "Blue Bell",
   "Blue Chalk",
   "Blue Charcoal",
   "Blue Chill",
   "Blue Diamond",
   "Blue Dianne",
   "Blue Gem",
   "Blue Gray",
   "Blue Green",
   "Blue Haze",
   "Blue Jeans",
   "Blue Lagoon",
   "Blue Magenta Violet",
   "Blue Marguerite",
   "Blue Ribbon",
   "Blue Romance",
   "Blue Sapphire",
   "Blue Smoke",
   "Blue Stone",
   "Blue Violet",
   "Blue Whale",
   "Blue Yonder",
   "Blue Zodiac",
   "Blueberry",
   "Bluebonnet",
   "Blumine",
   "Blush",
   "Bole",
   "Bombay",
   "Bon Jour",
   "Bondi Blue",
   "Bone",
   "Booger Buster",
   "Bordeaux",
   "Bossanova",
   "Boston Blue",
   "Boston University Red",
   "Botticelli",
   "Bottle Green",
   "Boulder",
   "Bouquet",
   "Bourbon",
   "Boysenberry",
   "Bracken",
   "Brandeis Blue",
   "Brandy",
   "Brandy Punch",
   "Brandy Rose",
   "Brass",
   "Breaker Bay",
   "Brick Red",
   "Bridal Heath",
   "Bridesmaid",
   "Bright Cerulean",
   "Bright Gray",
   "Bright Green",
   "Bright Lavender",
   "Bright Lilac",
   "Bright Maroon",
   "Bright Navy Blue",
   "Bright Red",
   "Bright Sun",
   "Bright Turquoise",
   "Bright Ube",
   "Bright Yellow",
   "Brilliant Azure",
   "Brilliant Lavender",
   "Brilliant Rose",
   "Brink Pink",
   "British Racing Green",
   "Bronco",
   "Bronze",
   "Bronze Olive",
   "Bronze Yellow",
   "Bronzetone",
   "Broom",
   "Brown",
   "Brown Bramble",
   "Brown Derby",
   "Brown Pod",
   "Brown Rust",
   "Brown Sugar",
   "Brown Tumbleweed",
   "Brown Yellow",
   "Brunswick Green",
   "Bubble Gum",
   "Bubbles",
   "Buccaneer",
   "Bud",
   "Bud Green",
   "Buddha Gold",
   "Buff",
   "Bulgarian Rose",
   "Bull Shot",
   "Bunker",
   "Bunting",
   "Burgundy",
   "Burlywood",
   "Burnham",
   "Burning Orange",
   "Burning Sand",
   "Burnished Brown",
   "Burnt Maroon",
   "Burnt Orange",
   "Burnt Sienna",
   "Burnt Umber",
   "Bush",
   "Buttercup",
   "Buttered Rum",
   "Butterfly Bush",
   "Buttermilk",
   "Buttery White",
   "Byzantine",
   "Byzantium",
   "CG Blue",
   "CG Red",
   "Cab Sav",
   "Cabaret",
   "Cabbage Pont",
   "Cactus",
   "Cadet",
   "Cadet Blue",
   "Cadet Grey",
   "Cadillac",
   "Cadmium Green",
   "Cadmium Orange",
   "Cadmium Red",
   "Cadmium Yellow",
   "Cafe Noir",
   "Cafe Royale",
   "Cal Poly Green",
   "Calico",
   "California",
   "Calypso",
   "Camarone",
   "Cambridge Blue",
   "Camelot",
   "Cameo",
   "Cameo Pink",
   "Camouflage",
   "Camouflage Green",
   "Can Can",
   "Canary",
   "Canary Yellow",
   "Candlelight",
   "Candy Apple Red",
   "Cannon Black",
   "Cannon Pink",
   "Cape Cod",
   "Cape Honey",
   "Cape Palliser",
   "Caper",
   "Capri",
   "Caput Mortuum",
   "Caramel",
   "Cararra",
   "Cardin Green",
   "Cardinal",
   "Cardinal Pink",
   "Careys Pink",
   "Caribbean Green",
   "Carissma",
   "Carla",
   "Carmine",
   "Carmine Pink",
   "Carmine Red",
   "Carnaby Tan",
   "Carnation",
   "Carnation Pink",
   "Carnelian",
   "Carolina Blue",
   "Carousel Pink",
   "Carrot Orange",
   "Casablanca",
   "Casal",
   "Cascade",
   "Cashmere",
   "Casper",
   "Castleton Green",
   "Castro",
   "Catalina Blue",
   "Catawba",
   "Catskill White",
   "Cavern Pink",
   "Cedar",
   "Cedar Chest",
   "Cedar Wood Finish",
   "Ceil",
   "Celadon",
   "Celadon Green",
   "Celery",
   "Celeste",
   "Celestial Blue",
   "Cello",
   "Celtic",
   "Cement",
   "Ceramic",
   "Cerise",
   "Cerise Pink",
   "Cerulean",
   "Cerulean Blue",
   "Cerulean Frost",
   "Chablis",
   "Chalet Green",
   "Chalky",
   "Chambray",
   "Chamois",
   "Chamoisee",
   "Champagne",
   "Chantilly",
   "Charade",
   "Charcoal",
   "Chardon",
   "Chardonnay",
   "Charleston Green",
   "Charlotte",
   "Charm",
   "Charm Pink",
   "Chartreuse",
   "Chateau Green",
   "Chatelle",
   "Chathams Blue",
   "Chelsea Cucumber",
   "Chelsea Gem",
   "Chenin",
   "Cherokee",
   "Cherry Blossom Pink",
   "Cherry Pie",
   "Cherrywood",
   "Cherub",
   "Chestnut",
   "Chetwode Blue",
   "Chicago",
   "Chiffon",
   "Chilean Fire",
   "Chilean Heath",
   "China Ivory",
   "China Rose",
   "Chinese Red",
   "Chinese Violet",
   "Chino",
   "Chinook",
   "Chlorophyll Green",
   "Chocolate",
   "Christalle",
   "Christi",
   "Christine",
   "Chrome White",
   "Chrome Yellow",
   "Cinder",
   "Cinderella",
   "Cinereous",
   "Cinnabar",
   "Cinnamon Satin",
   "Cioccolato",
   "Citrine",
   "Citrine White",
   "Citron",
   "Citrus",
   "Clairvoyant",
   "Clam Shell",
   "Claret",
   "Classic Rose",
   "Clay Ash",
   "Clay Creek",
   "Clear Day",
   "Clementine",
   "Clinker",
   "Cloud",
   "Cloud Burst",
   "Cloudy",
   "Clover",
   "Cobalt Blue",
   "Cocoa Bean",
   "Cocoa Brown",
   "Coconut",
   "Coconut Cream",
   "Cod Gray",
   "Coffee",
   "Coffee Bean",
   "Cognac",
   "Cola",
   "Cold Purple",
   "Cold Turkey",
   "Colonial White",
   "Columbia Blue",
   "Comet",
   "Como",
   "Conch",
   "Concord",
   "Concrete",
   "Confetti",
   "Congo Brown",
   "Congo Pink",
   "Congress Blue",
   "Conifer",
   "Contessa",
   "Cool Black",
   "Cool Grey",
   "Copper",
   "Copper Canyon",
   "Copper Penny",
   "Copper Red",
   "Copper Rose",
   "Copper Rust",
   "Coquelicot",
   "Coral",
   "Coral Red",
   "Coral Reef",
   "Coral Tree",
   "Cordovan",
   "Corduroy",
   "Coriander",
   "Cork",
   "Corn",
   "Corn Field",
   "Corn Harvest",
   "Cornflower Blue",
   "Cornflower Lilac",
   "Cornsilk",
   "Corvette",
   "Cosmic",
   "Cosmic Cobalt",
   "Cosmic Latte",
   "Cosmos",
   "Costa Del Sol",
   "Cotton Candy",
   "Cotton Seed",
   "County Green",
   "Cowboy",
   "Coyote Brown",
   "Crail",
   "Cranberry",
   "Crater Brown",
   "Crayola Blue",
   "Crayola Green",
   "Crayola Orange",
   "Crayola Red",
   "Crayola Yellow",
   "Cream",
   "Cream Brulee",
   "Cream Can",
   "Creole",
   "Crete",
   "Crimson",
   "Crimson Glory",
   "Crimson Red",
   "Crocodile",
   "Crown of Thorns",
   "Crowshead",
   "Cruise",
   "Crusoe",
   "Crusta",
   "Cumin",
   "Cumulus",
   "Cupid",
   "Curious Blue",
   "Cutty Sark",
   "Cyan",
   "Cyan Azure",
   "Cyan Blue Azure",
   "Cyan Cobalt Blue",
   "Cyan Cornflower Blue",
   "Cyber Grape",
   "Cyber Yellow",
   "Cyclamen",
   "Cyprus",
   "Daffodil",
   "Daintree",
   "Dairy Cream",
   "Daisy Bush",
   "Dallas",
   "Dandelion",
   "Danube",
   "Dark Blue",
   "Dark Blue Gray",
   "Dark Brown",
   "Dark Brown Tangelo",
   "Dark Burgundy",
   "Dark Byzantium",
   "Dark Candy Apple Red",
   "Dark Cerulean",
   "Dark Chestnut",
   "Dark Coral",
   "Dark Cyan",
   "Dark Ebony",
   "Dark Fern",
   "Dark Goldenrod",
   "Dark Green",
   "Dark Gunmetal",
   "Dark Imperial Blue",
   "Dark Jungle Green",
   "Dark Khaki",
   "Dark Lavender",
   "Dark Liver",
   "Dark Magenta",
   "Dark Medium Gray",
   "Dark Midnight Blue",
   "Dark Moss Green",
   "Dark Olive Green",
   "Dark Orange",
   "Dark Orchid",
   "Dark Pastel Blue",
   "Dark Pastel Green",
   "Dark Pastel Purple",
   "Dark Pastel Red",
   "Dark Pink",
   "Dark Puce",
   "Dark Purple",
   "Dark Raspberry",
   "Dark Red",
   "Dark Salmon",
   "Dark Scarlet",
   "Dark Sea Green",
   "Dark Sienna",
   "Dark Sky Blue",
   "Dark Slate Blue",
   "Dark Slate Gray",
   "Dark Spring Green",
   "Dark Tan",
   "Dark Tangerine",
   "Dark Terra Cotta",
   "Dark Turquoise",
   "Dark Vanilla",
   "Dark Violet",
   "Dark Yellow",
   "Dartmouth Green",
   "Davys Grey",
   "Dawn",
   "Dawn Pink",
   "De York",
   "Debian Red",
   "Deco",
   "Deep Blue",
   "Deep Blush",
   "Deep Bronze",
   "Deep Carmine",
   "Deep Carmine Pink",
   "Deep Carrot Orange",
   "Deep Cerise",
   "Deep Chestnut",
   "Deep Cove",
   "Deep Fir",
   "Deep Forest Green",
   "Deep Fuchsia",
   "Deep Green",
   "Deep Green Cyan Turquoise",
   "Deep Jungle Green",
   "Deep Koamaru",
   "Deep Lemon",
   "Deep Lilac",
   "Deep Magenta",
   "Deep Maroon",
   "Deep Oak",
   "Deep Pink",
   "Deep Puce",
   "Deep Red",
   "Deep Ruby",
   "Deep Saffron",
   "Deep Sapphire",
   "Deep Sea",
   "Deep Sea Green",
   "Deep Space Sparkle",
   "Deep Taupe",
   "Deep Teal",
   "Deep Tuscan Red",
   "Deep Violet",
   "Deer",
   "Del Rio",
   "Dell",
   "Delta",
   "Deluge",
   "Denim",
   "Denim Blue",
   "Derby",
   "Desaturated Cyan",
   "Desert",
   "Desert Sand",
   "Desert Storm",
   "Desire",
   "Dew",
   "Di Serria",
   "Diamond",
   "Diesel",
   "Dim Gray",
   "Dingley",
   "Dingy Dungeon",
   "Dirt",
   "Disco",
   "Dixie",
   "Dodger Blue",
   "Dogs",
   "Dogwood Rose",
   "Dollar Bill",
   "Dolly",
   "Dolphin",
   "Domino",
   "Don Juan",
   "Donkey Brown",
   "Dorado",
   "Double Colonial White",
   "Double Pearl Lusta",
   "Double Spanish White",
   "Dove Gray",
   "Downriver",
   "Downy",
   "Driftwood",
   "Drover",
   "Duke Blue",
   "Dull Lavender",
   "Dune",
   "Dust Storm",
   "Dusty Gray",
   "Dutch White",
   "Eagle",
   "Eagle Green",
   "Earls Green",
   "Early Dawn",
   "Earth Yellow",
   "East Bay",
   "East Side",
   "Eastern Blue",
   "Ebb",
   "Ebony",
   "Ebony Clay",
   "Eclipse",
   "Ecru",
   "Ecru White",
   "Ecstasy",
   "Eden",
   "Edgewater",
   "Edward",
   "Eerie Black",
   "Egg Sour",
   "Egg White",
   "Eggplant",
   "Eggshell",
   "Egyptian Blue",
   "El Paso",
   "El Salva",
   "Electric Blue",
   "Electric Crimson",
   "Electric Indigo",
   "Electric Lime",
   "Electric Purple",
   "Electric Violet",
   "Electric Yellow",
   "Elephant",
   "Elf Green",
   "Elm",
   "Emerald",
   "Eminence",
   "Emperor",
   "Empress",
   "Endeavour",
   "Energy Yellow",
   "Engineering International Orange",
   "English Holly",
   "English Lavender",
   "English Red",
   "English Vermillion",
   "English Walnut",
   "Envy",
   "Equator",
   "Espresso",
   "Eternity",
   "Eton Blue",
   "Eucalyptus",
   "Eunry",
   "Evening Sea",
   "Everglade",
   "FOGRA29 Rich Black",
   "FOGRA39 Rich Black",
   "Faded Jade",
   "Fair Pink",
   "Falcon",
   "Fallow",
   "Falu Red",
   "Fandango",
   "Fandango Pink",
   "Fantasy",
   "Fashion Fuchsia",
   "Fawn",
   "Fedora",
   "Feijoa",
   "Feldgrau",
   "Fern",
   "Fern Frond",
   "Fern Green",
   "Ferra",
   "Ferrari Red",
   "Festival",
   "Feta",
   "Field Drab",
   "Fiery Orange",
   "Fiery Rose",
   "Finch",
   "Finlandia",
   "Finn",
   "Fiord",
   "Fire",
   "Fire Bush",
   "Fire Engine Red",
   "Firebrick",
   "Firefly",
   "Flame",
   "Flame Pea",
   "Flamenco",
   "Flamingo",
   "Flamingo Pink",
   "Flavescent",
   "Flax",
   "Flax Smoke",
   "Flint",
   "Flirt",
   "Floral White",
   "Flush Mahogany",
   "Foam",
   "Fog",
   "Foggy Gray",
   "Folly",
   "Forest Green",
   "Forget Me Not",
   "Fountain Blue",
   "Frangipani",
   "French Bistre",
   "French Blue",
   "French Fuchsia",
   "French Gray",
   "French Lilac",
   "French Lime",
   "French Mauve",
   "French Pass",
   "French Pink",
   "French Plum",
   "French Puce",
   "French Raspberry",
   "French Rose",
   "French Sky Blue",
   "French Violet",
   "French Wine",
   "Fresh Air",
   "Fresh Eggplant",
   "Friar Gray",
   "Fringy Flower",
   "Froly",
   "Frost",
   "Frostbite",
   "Frosted Mint",
   "Frostee",
   "Fruit Salad",
   "Fuchsia",
   "Fuchsia Blue",
   "Fuchsia Pink",
   "Fuchsia Purple",
   "Fuchsia Rose",
   "Fuego",
   "Fuel Yellow",
   "Fulvous",
   "Fun Blue",
   "Fun Green",
   "Fuscous Gray",
   "Fuzzy Wuzzy",
   "Fuzzy Wuzzy Brown",
   "GO Green",
   "Gable Green",
   "Gainsboro",
   "Gallery",
   "Galliano",
   "Gamboge",
   "Gamboge Orange",
   "Gargoyle Gas",
   "Geebung",
   "Generic Viridian",
   "Genoa",
   "Geraldine",
   "Geyser",
   "Ghost",
   "Ghost White",
   "Giants Club",
   "Giants Orange",
   "Gigas",
   "Gimblet",
   "Gin",
   "Gin Fizz",
   "Ginger",
   "Givry",
   "Glacier",
   "Glade Green",
   "Glaucous",
   "Glitter",
   "Glossy Grape",
   "Go Ben",
   "Goblin",
   "Gold Drop",
   "Gold Fusion",
   "Gold Tips",
   "Golden",
   "Golden Bell",
   "Golden Brown",
   "Golden Dream",
   "Golden Fizz",
   "Golden Gate Bridge",
   "Golden Glow",
   "Golden Poppy",
   "Golden Sand",
   "Golden Tainoi",
   "Golden Yellow",
   "Goldenrod",
   "Gondola",
   "Gordons Green",
   "Gorse",
   "Gossamer",
   "Gossip",
   "Gothic",
   "Governor Bay",
   "Grain Brown",
   "Grandis",
   "Granite Gray",
   "Granite Green",
   "Granny Apple",
   "Granny Smith",
   "Granny Smith Apple",
   "Grape",
   "Graphite",
   "Gravel",
   "Gray",
   "Gray Asparagus",
   "Gray Chateau",
   "Gray Nickel",
   "Gray Nurse",
   "Gray Olive",
   "Gray Suit",
   "Green",
   "Green Blue",
   "Green Cyan",
   "Green Haze",
   "Green House",
   "Green Kelp",
   "Green Leaf",
   "Green Lizard",
   "Green Mist",
   "Green Pea",
   "Green Sheen",
   "Green Smoke",
   "Green Spring",
   "Green Vogue",
   "Green Waterloo",
   "Green White",
   "Green Yellow",
   "Grenadier",
   "Grizzly",
   "Grullo",
   "Guardsman Red",
   "Gulf Blue",
   "Gulf Stream",
   "Gull Gray",
   "Gum Leaf",
   "Gumbo",
   "Gun Powder",
   "Gunmetal",
   "Gunsmoke",
   "Gurkha",
   "Hacienda",
   "Hairy Heath",
   "Haiti",
   "Halayà Úbe",
   "Half Baked",
   "Half Colonial White",
   "Half Dutch White",
   "Half Spanish White",
   "Half and Half",
   "Hampton",
   "Han Blue",
   "Han Purple",
   "Harlequin",
   "Harlequin Green",
   "Harp",
   "Harvard Crimson",
   "Harvest Gold",
   "Havelock Blue",
   "Hawaiian Tan",
   "Hawkes Blue",
   "Heat Wave",
   "Heath",
   "Heather",
   "Heathered Gray",
   "Heavy Metal",
   "Heliotrope",
   "Heliotrope Gray",
   "Heliotrope Magenta",
   "Hemlock",
   "Hemp",
   "Hibiscus",
   "Highland",
   "Hillary",
   "Himalaya",
   "Hint of Green",
   "Hint of Red",
   "Hint of Yellow",
   "Hippie Blue",
   "Hippie Green",
   "Hippie Pink",
   "Hit Gray",
   "Hit Pink",
   "Hokey Pokey",
   "Hoki",
   "Holly",
   "Honey Flower",
   "Honeydew",
   "Honeysuckle",
   "Honolulu Blue",
   "Hookers Green",
   "Hopbush",
   "Horizon",
   "Horses",
   "Horses Neck",
   "Hot Magenta",
   "Hot Pink",
   "Hot Toddy",
   "Humming Bird",
   "Hunter Green",
   "Hurricane",
   "Husk",
   "Ice Cold",
   "Iceberg",
   "Icterine",
   "Illuminating Emerald",
   "Illusion",
   "Imperial",
   "Imperial Blue",
   "Imperial Red",
   "Inch Worm",
   "Inchworm",
   "Independence",
   "India Green",
   "Indian Red",
   "Indian Tan",
   "Indian Yellow",
   "Indigo",
   "Indigo Dye",
   "Indochine",
   "International Klein Blue",
   "International Orange",
   "Iris",
   "Irish Coffee",
   "Iroko",
   "Iron",
   "Ironside Gray",
   "Ironstone",
   "Irresistible",
   "Isabelline",
   "Islamic Green",
   "Island Spice",
   "Ivory",
   "Jacaranda",
   "Jacarta",
   "Jacko Bean",
   "Jacksons Purple",
   "Jade",
   "Jaffa",
   "Jagged Ice",
   "Jagger",
   "Jaguar",
   "Jambalaya",
   "Janna",
   "Japanese Carmine",
   "Japanese Indigo",
   "Japanese Laurel",
   "Japanese Maple",
   "Japanese Violet",
   "Japonica",
   "Jasmine",
   "Jasper",
   "Java",
   "Jazzberry Jam",
   "Jelly Bean",
   "Jet",
   "Jet Stream",
   "Jewel",
   "Jon",
   "Jonquil",
   "Jordy Blue",
   "Judge Gray",
   "Jumbo",
   "June Bud",
   "Jungle Green",
   "Jungle Mist",
   "Juniper",
   "Just Right",
   "KU Crimson",
   "Kabul",
   "Kaitoke Green",
   "Kangaroo",
   "Karaka",
   "Karry",
   "Kashmir Blue",
   "Kelly Green",
   "Kelp",
   "Kenyan Copper",
   "Keppel",
   "Key Lime",
   "Key Lime Pie",
   "Khaki",
   "Kidnapper",
   "Kilamanjaro",
   "Killarney",
   "Kimberly",
   "Kingfisher Daisy",
   "Kobi",
   "Kobicha",
   "Kokoda",
   "Kombu Green",
   "Korma",
   "Koromiko",
   "Kournikova",
   "Kumera",
   "La Palma",
   "La Rioja",
   "La Salle Green",
   "Languid Lavender",
   "Lapis Lazuli",
   "Las Palmas",
   "Laser",
   "Laurel",
   "Laurel Green",
   "Lava",
   "Lavender",
   "Lavender Blush",
   "Lavender Gray",
   "Lavender Indigo",
   "Lavender Magenta",
   "Lavender Mist",
   "Lavender Pink",
   "Lavender Purple",
   "Lavender Rose",
   "Lawn Green",
   "Leather",
   "Lemon",
   "Lemon Chiffon",
   "Lemon Curry",
   "Lemon Ginger",
   "Lemon Glacier",
   "Lemon Grass",
   "Lemon Lime",
   "Lemon Meringue",
   "Lemon Yellow",
   "Lenurple",
   "Liberty",
   "Licorice",
   "Light Apricot",
   "Light Blue",
   "Light Brilliant Red",
   "Light Brown",
   "Light Carmine Pink",
   "Light Cobalt Blue",
   "Light Coral",
   "Light Cornflower Blue",
   "Light Crimson",
   "Light Cyan",
   "Light Deep Pink",
   "Light French Beige",
   "Light Fuchsia Pink",
   "Light Goldenrod Yellow",
   "Light Gray",
   "Light Grayish Magenta",
   "Light Green",
   "Light Hot Pink",
   "Light Khaki",
   "Light Medium Orchid",
   "Light Moss Green",
   "Light Orchid",
   "Light Pastel Purple",
   "Light Pink",
   "Light Salmon",
   "Light Salmon Pink",
   "Light Sea Green",
   "Light Sky Blue",
   "Light Slate Gray",
   "Light Steel Blue",
   "Light Taupe",
   "Light Turquoise",
   "Light Yellow",
   "Lightning Yellow",
   "Lilac",
   "Lilac Bush",
   "Lilac Luster",
   "Lily",
   "Lily White",
   "Lima",
   "Lime",
   "Lime Green",
   "Limeade",
   "Limed Ash",
   "Limed Oak",
   "Limed Spruce",
   "Limerick",
   "Lincoln Green",
   "Linen",
   "Link Water",
   "Lipstick",
   "Lisbon Brown",
   "Little Boy Blue",
   "Liver",
   "Liver Chestnut",
   "Livid Brown",
   "Loafer",
   "Loblolly",
   "Lochinvar",
   "Lochmara",
   "Locust",
   "Log Cabin",
   "Logan",
   "Lola",
   "London Hue",
   "Lonestar",
   "Lotus",
   "Loulou",
   "Lucky",
   "Lucky Point",
   "Lumber",
   "Lunar Green",
   "Lust",
   "Luxor Gold",
   "Lynch",
   "MSU Green",
   "Mabel",
   "Macaroni And Cheese",
   "Macaroni and Cheese",
   "Madang",
   "Madison",
   "Madras",
   "Magenta",
   "Magenta Haze",
   "Magenta Pink",
   "Magic Mint",
   "Magic Potion",
   "Magnolia",
   "Mahogany",
   "Mai Tai",
   "Maize",
   "Majorelle Blue",
   "Makara",
   "Mako",
   "Malachite",
   "Malibu",
   "Mallard",
   "Malta",
   "Mamba",
   "Manatee",
   "Mandalay",
   "Mandarin",
   "Mandy",
   "Mandys Pink",
   "Mango Tango",
   "Manhattan",
   "Mantis",
   "Mantle",
   "Manz",
   "Mardi Gras",
   "Marigold",
   "Marigold Yellow",
   "Mariner",
   "Maroon",
   "Maroon Oak",
   "Marshland",
   "Martini",
   "Martinique",
   "Marzipan",
   "Masala",
   "Matisse",
   "Matrix",
   "Matterhorn",
   "Mauve",
   "Mauve Taupe",
   "Mauvelous",
   "Maverick",
   "Maximum Blue",
   "Maximum Yellow",
   "May Green",
   "Maya Blue",
   "Meat Brown",
   "Medium Aquamarine",
   "Medium Blue",
   "Medium Candy Apple Red",
   "Medium Electric Blue",
   "Medium Jungle Green",
   "Medium Orchid",
   "Medium Purple",
   "Medium Red Violet",
   "Medium Ruby",
   "Medium Sea Green",
   "Medium Sky Blue",
   "Medium Slate Blue",
   "Medium Spring Bud",
   "Medium Spring Green",
   "Medium Turquoise",
   "Medium Vermilion",
   "Melanie",
   "Melanzane",
   "Mellow Apricot",
   "Melon",
   "Melrose",
   "Mercury",
   "Merino",
   "Merlin",
   "Merlot",
   "Metal Pink",
   "Metallic Bronze",
   "Metallic Copper",
   "Metallic Gold",
   "Metallic Seaweed",
   "Metallic Sunburst",
   "Meteor",
   "Meteorite",
   "Mexican Pink",
   "Mexican Red",
   "Mid Gray",
   "Midnight",
   "Midnight Blue",
   "Midnight Moss",
   "Mikado",
   "Mikado Yellow",
   "Milan",
   "Milano Red",
   "Milk Punch",
   "Millbrook",
   "Mimosa",
   "Mindaro",
   "Mine Shaft",
   "Mineral Green",
   "Ming",
   "Minion Yellow",
   "Minsk",
   "Mint",
   "Mint Cream",
   "Mint Green",
   "Mint Julep",
   "Mint Tulip",
   "Mirage",
   "Mischka",
   "Mist Gray",
   "Misty Moss",
   "Misty Rose",
   "Mobster",
   "Moccaccino",
   "Moccasin",
   "Mocha",
   "Mojo",
   "Mona Lisa",
   "Monarch",
   "Mondo",
   "Mongoose",
   "Monsoon",
   "Monte Carlo",
   "Monza",
   "Moody Blue",
   "Moon Glow",
   "Moon Mist",
   "Moon Raker",
   "Moonstone Blue",
   "Mordant Red",
   "Morning Glory",
   "Morocco Brown",
   "Mortar",
   "Mosque",
   "Moss Green",
   "Mountain Meadow",
   "Mountain Mist",
   "Mountbatten Pink",
   "Muddy Waters",
   "Muesli",
   "Mughal Green",
   "Mulberry",
   "Mulberry Wood",
   "Mule Fawn",
   "Mulled Wine",
   "Mummys Tomb",
   "Munsell Blue",
   "Munsell Green",
   "Munsell Purple",
   "Munsell Red",
   "Munsell Yellow",
   "Mustard",
   "My Pink",
   "My Sin",
   "Myrtle Green",
   "Mystic",
   "Mystic Maroon",
   "NCS Blue",
   "NCS Green",
   "NCS Red",
   "Nadeshiko Pink",
   "Nandor",
   "Napa",
   "Napier Green",
   "Naples Yellow",
   "Narvik",
   "Natural Gray",
   "Navajo White",
   "Navy",
   "Nebula",
   "Negroni",
   "Neon Carrot",
   "Neon Fuchsia",
   "Neon Green",
   "Nepal",
   "Neptune",
   "Nero",
   "Nevada",
   "New Car",
   "New Orleans",
   "New York Pink",
   "Niagara",
   "Nickel",
   "Night Rider",
   "Night Shadz",
   "Nile Blue",
   "Nobel",
   "Nomad",
   "Non Photo Blue",
   "North Texas Green",
   "Norway",
   "Nugget",
   "Nutmeg",
   "Nutmeg Wood Finish",
   "Nyanza",
   "Oasis",
   "Observatory",
   "Ocean Blue",
   "Ocean Boat Blue",
   "Ocean Green",
   "Ochre",
   "Off Green",
   "Off Yellow",
   "Ogre Odor",
   "Oil",
   "Old Brick",
   "Old Burgundy",
   "Old Copper",
   "Old Gold",
   "Old Heliotrope",
   "Old Lace",
   "Old Lavender",
   "Old Moss Green",
   "Old Rose",
   "Old Silver",
   "Olive",
   "Olive Drab",
   "Olive Drab Seven",
   "Olive Green",
   "Olive Haze",
   "Olivetone",
   "Olivine",
   "Onahau",
   "Onion",
   "Onyx",
   "Opal",
   "Opera Mauve",
   "Opium",
   "Oracle",
   "Orange",
   "Orange Peel",
   "Orange Red",
   "Orange Roughy",
   "Orange Soda",
   "Orange White",
   "Orange Yellow",
   "Orchid",
   "Orchid Pink",
   "Orchid White",
   "Oregon",
   "Organ",
   "Orient",
   "Oriental Pink",
   "Orinoco",
   "Orioles Orange",
   "Oslo Gray",
   "Ottoman",
   "Outer Space",
   "Outrageous Orange",
   "Oxford Blue",
   "Oxley",
   "Oyster Bay",
   "Oyster Pink",
   "Paarl",
   "Pablo",
   "Pacific Blue",
   "Pacifika",
   "Paco",
   "Padua",
   "Pakistan Green",
   "Palatinate Blue",
   "Palatinate Purple",
   "Pale Brown",
   "Pale Canary",
   "Pale Carmine",
   "Pale Cerulean",
   "Pale Chestnut",
   "Pale Copper",
   "Pale Cornflower Blue",
   "Pale Cyan",
   "Pale Gold",
   "Pale Goldenrod",
   "Pale Green",
   "Pale Lavender",
   "Pale Leaf",
   "Pale Magenta",
   "Pale Magenta Pink",
   "Pale Oyster",
   "Pale Pink",
   "Pale Plum",
   "Pale Prim",
   "Pale Red Violet",
   "Pale Robin Egg Blue",
   "Pale Rose",
   "Pale Silver",
   "Pale Sky",
   "Pale Slate",
   "Pale Spring Bud",
   "Pale Taupe",
   "Pale Violet",
   "Palm Green",
   "Palm Leaf",
   "Pampas",
   "Panache",
   "Pancho",
   "Pansy Purple",
   "Pantone Blue",
   "Pantone Green",
   "Pantone Magenta",
   "Pantone Orange",
   "Pantone Pink",
   "Pantone Yellow",
   "Paolo Veronese Green",
   "Papaya Whip",
   "Paprika",
   "Paradise Pink",
   "Paradiso",
   "Parchment",
   "Paris Daisy",
   "Paris M",
   "Paris White",
   "Parsley",
   "Pastel Blue",
   "Pastel Brown",
   "Pastel Gray",
   "Pastel Green",
   "Pastel Magenta",
   "Pastel Orange",
   "Pastel Pink",
   "Pastel Purple",
   "Pastel Red",
   "Pastel Violet",
   "Pastel Yellow",
   "Patina",
   "Pattens Blue",
   "Paua",
   "Pavlova",
   "Paynes Grey",
   "Peach",
   "Peach Cream",
   "Peach Orange",
   "Peach Puff",
   "Peach Schnapps",
   "Peach Yellow",
   "Peanut",
   "Pear",
   "Pearl",
   "Pearl Aqua",
   "Pearl Bush",
   "Pearl Lusta",
   "Pearl Mystic Turquoise",
   "Pearly Purple",
   "Peat",
   "Pelorous",
   "Peppermint",
   "Perano",
   "Perfume",
   "Peridot",
   "Periglacial Blue",
   "Periwinkle",
   "Periwinkle Gray",
   "Permanent Geranium Lake",
   "Persian Blue",
   "Persian Green",
   "Persian Indigo",
   "Persian Orange",
   "Persian Pink",
   "Persian Plum",
   "Persian Red",
   "Persian Rose",
   "Persimmon",
   "Peru",
   "Peru Tan",
   "Pesto",
   "Petite Orchid",
   "Pewter",
   "Pewter Blue",
   "Pharlap",
   "Phthalo Blue",
   "Phthalo Green",
   "Picasso",
   "Pickled Bean",
   "Pickled Bluewood",
   "Picton Blue",
   "Pictorial Carmine",
   "Pig Pink",
   "Pigeon Post",
   "Piggy Pink",
   "Pigment Blue",
   "Pigment Green",
   "Pigment Red",
   "Pine Cone",
   "Pine Glade",
   "Pine Green",
   "Pine Tree",
   "Pink",
   "Pink Flamingo",
   "Pink Flare",
   "Pink Lace",
   "Pink Lady",
   "Pink Lavender",
   "Pink Orange",
   "Pink Pearl",
   "Pink Raspberry",
   "Pink Sherbet",
   "Pink Swan",
   "Piper",
   "Pipi",
   "Pippin",
   "Pirate Gold",
   "Pistachio",
   "Pixie Green",
   "Pixie Powder",
   "Pizazz",
   "Pizza",
   "Plantation",
   "Platinum",
   "Plum",
   "Plump Purple",
   "Pohutukawa",
   "Polar",
   "Polished Pine",
   "Polo Blue",
   "Pomegranate",
   "Pompadour",
   "Popstar",
   "Porcelain",
   "Porsche",
   "Port Gore",
   "Portafino",
   "Portage",
   "Portica",
   "Portland Orange",
   "Pot Pourri",
   "Potters Clay",
   "Powder Ash",
   "Powder Blue",
   "Prairie Sand",
   "Prelude",
   "Prim",
   "Primrose",
   "Princess Perfume",
   "Princeton Orange",
   "Process Cyan",
   "Process Magenta",
   "Provincial Pink",
   "Prussian Blue",
   "Psychedelic Purple",
   "Puce",
   "Pueblo",
   "Puerto Rico",
   "Pullman Brown",
   "Pullman Green",
   "Pumice",
   "Pumpkin",
   "Pumpkin Skin",
   "Punch",
   "Punga",
   "Purple",
   "Purple Heart",
   "Purple Mountain Majesty",
   "Purple Navy",
   "Purple Pizzazz",
   "Purple Plum",
   "Purple Taupe",
   "Purpureus",
   "Putty",
   "Quarter Pearl Lusta",
   "Quarter Spanish White",
   "Quartz",
   "Queen Blue",
   "Queen Pink",
   "Quick Silver",
   "Quicksand",
   "Quill Gray",
   "Quinacridone Magenta",
   "Quincy",
   "RYB Blue",
   "RYB Green",
   "RYB Orange",
   "RYB Red",
   "RYB Violet",
   "RYB Yellow",
   "Racing Green",
   "Radical Red",
   "Raffia",
   "Rainee",
   "Raisin Black",
   "Rajah",
   "Rangitoto",
   "Rangoon Green",
   "Raspberry",
   "Raspberry Pink",
   "Raven",
   "Raw Sienna",
   "Raw Umber",
   "Razzle Dazzle Rose",
   "Razzmatazz",
   "Razzmic Berry",
   "Rebecca Purple",
   "Rebel",
   "Red",
   "Red Beech",
   "Red Berry",
   "Red Damask",
   "Red Devil",
   "Red Orange",
   "Red Oxide",
   "Red Purple",
   "Red Ribbon",
   "Red Robin",
   "Red Salsa",
   "Red Stage",
   "Red Violet",
   "Redwood",
   "Reef",
   "Reef Gold",
   "Regal Blue",
   "Regalia",
   "Regent Gray",
   "Regent St Blue",
   "Remy",
   "Reno Sand",
   "Resolution Blue",
   "Revolver",
   "Rhino",
   "Rhythm",
   "Rice Cake",
   "Rice Flower",
   "Rich Black",
   "Rich Brilliant Lavender",
   "Rich Carmine",
   "Rich Electric Blue",
   "Rich Gold",
   "Rich Lavender",
   "Rich Lilac",
   "Rich Maroon",
   "Rifle Green",
   "Rio Grande",
   "Ripe Lemon",
   "Ripe Plum",
   "Riptide",
   "River Bed",
   "Roast Coffee",
   "Rob Roy",
   "Robin Egg Blue",
   "Rock",
   "Rock Blue",
   "Rock Spray",
   "Rocket Metallic",
   "Rodeo Dust",
   "Rolling Stone",
   "Roman",
   "Roman Coffee",
   "Roman Silver",
   "Romance",
   "Romantic",
   "Ronchi",
   "Roof Terracotta",
   "Rope",
   "Rose",
   "Rose Bonbon",
   "Rose Bud",
   "Rose Bud Cherry",
   "Rose Dust",
   "Rose Ebony",
   "Rose Fog",
   "Rose Gold",
   "Rose Pink",
   "Rose Red",
   "Rose Taupe",
   "Rose Vale",
   "Rose White",
   "Rose of Sharon",
   "Rosewood",
   "Rosso Corsa",
   "Rosy Brown",
   "Roti",
   "Rouge",
   "Royal Air Force Blue",
   "Royal Azure",
   "Royal Blue",
   "Royal Fuchsia",
   "Royal Heath",
   "Royal Purple",
   "Ruber",
   "Rubine Red",
   "Ruby",
   "Ruby Red",
   "Ruddy",
   "Ruddy Brown",
   "Ruddy Pink",
   "Rufous",
   "Rum",
   "Rum Swizzle",
   "Russet",
   "Russett",
   "Russian Green",
   "Russian Violet",
   "Rust",
   "Rustic Red",
   "Rusty Nail",
   "Rusty Red",
   "SAE ECE Amber",
   "Sacramento State Green",
   "Saddle",
   "Saddle Brown",
   "Safety Orange",
   "Safety Yellow",
   "Saffron",
   "Saffron Mango",
   "Sage",
   "Sahara",
   "Sahara Sand",
   "Sail",
   "Salem",
   "Salmon",
   "Salmon Pink",
   "Salomie",
   "Salt Box",
   "Saltpan",
   "Sambuca",
   "San Felix",
   "San Juan",
   "San Marino",
   "Sand Dune",
   "Sandal",
   "Sandrift",
   "Sandstone",
   "Sandstorm",
   "Sandwisp",
   "Sandy Beach",
   "Sandy Brown",
   "Sangria",
   "Sanguine Brown",
   "Santa Fe",
   "Santas Gray",
   "Sap Green",
   "Sapling",
   "Sapphire",
   "Sapphire Blue",
   "Saratoga",
   "Sasquatch Socks",
   "Satin Linen",
   "Satin Sheen Gold",
   "Sauvignon",
   "Sazerac",
   "Scampi",
   "Scandal",
   "Scarlet",
   "Scarlet Gum",
   "Scarlett",
   "Scarpa Flow",
   "Schist",
   "School Bus Yellow",
   "Schooner",
   "Science Blue",
   "Scooter",
   "Scorpion",
   "Scotch Mist",
   "Screamin Green",
   "Sea Blue",
   "Sea Buckthorn",
   "Sea Green",
   "Sea Mist",
   "Sea Nymph",
   "Sea Pink",
   "Sea Serpent",
   "Seagull",
   "Seal Brown",
   "Seance",
   "Seashell",
   "Seaweed",
   "Selago",
   "Selective Yellow",
   "Sepia",
   "Sepia Black",
   "Sepia Skin",
   "Serenade",
   "Shadow",
   "Shadow Blue",
   "Shadow Green",
   "Shady Lady",
   "Shakespeare",
   "Shalimar",
   "Shampoo",
   "Shamrock",
   "Shamrock Green",
   "Shark",
   "Sheen Green",
   "Sherpa Blue",
   "Sherwood Green",
   "Shilo",
   "Shimmering Blush",
   "Shingle Fawn",
   "Shiny Shamrock",
   "Ship Cove",
   "Ship Gray",
   "Shiraz",
   "Shocking",
   "Shocking Pink",
   "Shuttle Gray",
   "Siam",
   "Sidecar",
   "Sienna",
   "Silk",
   "Silver",
   "Silver Chalice",
   "Silver Lake Blue",
   "Silver Pink",
   "Silver Sand",
   "Silver Tree",
   "Sinbad",
   "Sinopia",
   "Siren",
   "Sirocco",
   "Sisal",
   "Sizzling Red",
   "Sizzling Sunrise",
   "Skeptic",
   "Skobeloff",
   "Sky Blue",
   "Sky Magenta",
   "Slate Blue",
   "Slate Gray",
   "Slimy Green",
   "Smalt",
   "Smalt Blue",
   "Smashed Pumpkin",
   "Smitten",
   "Smoke",
   "Smokey Topaz",
   "Smoky",
   "Smoky Black",
   "Smoky Topaz",
   "Snow",
   "Snow Drift",
   "Snow Flurry",
   "Snowy Mint",
   "Snuff",
   "Soap",
   "Soapstone",
   "Soft Amber",
   "Soft Peach",
   "Solid Pink",
   "Solitaire",
   "Solitude",
   "Sonic Silver",
   "Sorbus",
   "Sorrell Brown",
   "Soya Bean",
   "Space Cadet",
   "Spanish Bistre",
   "Spanish Blue",
   "Spanish Carmine",
   "Spanish Crimson",
   "Spanish Gray",
   "Spanish Green",
   "Spanish Orange",
   "Spanish Pink",
   "Spanish Red",
   "Spanish Sky Blue",
   "Spanish Violet",
   "Spanish Viridian",
   "Spartan Crimson",
   "Spectra",
   "Spice",
   "Spicy Mix",
   "Spicy Mustard",
   "Spicy Pink",
   "Spindle",
   "Spiro Disco Ball",
   "Spray",
   "Spring Bud",
   "Spring Frost",
   "Spring Green",
   "Spring Leaves",
   "Spring Rain",
   "Spring Sun",
   "Spring Wood",
   "Sprout",
   "Spun Pearl",
   "Squirrel",
   "St Patricks Blue",
   "St Tropaz",
   "Stack",
   "Star Command Blue",
   "Star Dust",
   "Stark White",
   "Starship",
   "Steel Blue",
   "Steel Gray",
   "Steel Pink",
   "Steel Teal",
   "Stiletto",
   "Stonewall",
   "Storm Dust",
   "Storm Gray",
   "Stormcloud",
   "Stratos",
   "Straw",
   "Strawberry",
   "Strikemaster",
   "Stromboli",
   "Studio",
   "Submarine",
   "Sugar Cane",
   "Sugar Plum",
   "Sulu",
   "Summer Green",
   "Sun",
   "Sunburnt Cyclops",
   "Sundance",
   "Sundown",
   "Sunflower",
   "Sunglo",
   "Sunglow",
   "Sunny",
   "Sunray",
   "Sunset",
   "Sunset Orange",
   "Sunshade",
   "Super Pink",
   "Supernova",
   "Surf",
   "Surf Crest",
   "Surfie Green",
   "Sushi",
   "Suva Gray",
   "Swamp",
   "Swamp Green",
   "Swans Down",
   "Sweet Brown",
   "Sweet Corn",
   "Sweet Pink",
   "Swirl",
   "Swiss Coffee",
   "Sycamore",
   "Tabasco",
   "Tacao",
   "Tacha",
   "Tahiti Gold",
   "Tahuna Sands",
   "Tall Poppy",
   "Tallow",
   "Tamarillo",
   "Tamarind",
   "Tan",
   "Tan Hide",
   "Tana",
   "Tangaroa",
   "Tangelo",
   "Tangerine",
   "Tangerine Yellow",
   "Tango",
   "Tango Pink",
   "Tapa",
   "Tapestry",
   "Tara",
   "Tarawera",
   "Tart Orange",
   "Tasman",
   "Taupe",
   "Taupe Gray",
   "Tawny Port",
   "Te Papa Green",
   "Tea",
   "Tea Green",
   "Tea Rose",
   "Teak",
   "Teal",
   "Teal Blue",
   "Teal Deer",
   "Teal Green",
   "Telemagenta",
   "Temptress",
   "Tenne",
   "Tequila",
   "Terra Cotta",
   "Texas",
   "Texas Rose",
   "Thatch",
   "Thatch Green",
   "Thistle",
   "Thistle Green",
   "Thulian Pink",
   "Thunder",
   "Thunderbird",
   "Tia Maria",
   "Tiara",
   "Tiber",
   "Tickle Me Pink",
   "Tidal",
   "Tide",
   "Tiffany Blue",
   "Tigers Eye",
   "Timber Green",
   "Timberwolf",
   "Titan White",
   "Titanium Yellow",
   "Toast",
   "Tobacco Brown",
   "Toledo",
   "Tolopea",
   "Tom Thumb",
   "Tomato",
   "Tonys Pink",
   "Toolbox",
   "Topaz",
   "Torea Bay",
   "Tory Blue",
   "Tosca",
   "Totem Pole",
   "Tower Gray",
   "Tractor Red",
   "Tradewind",
   "Tranquil",
   "Travertine",
   "Tree Poppy",
   "Treehouse",
   "Trendy Green",
   "Trendy Pink",
   "Trinidad",
   "Tropical Blue",
   "Tropical Rain Forest",
   "Tropical Violet",
   "Trout",
   "True Blue",
   "True V",
   "Tuatara",
   "Tuft Bush",
   "Tufts Blue",
   "Tulip",
   "Tulip Tree",
   "Tumbleweed",
   "Tuna",
   "Tundora",
   "Turbo",
   "Turkish Rose",
   "Turmeric",
   "Turquoise",
   "Turquoise Blue",
   "Turquoise Green",
   "Turtle Green",
   "Tuscan Red",
   "Tuscan Tan",
   "Tuscany",
   "Tusk",
   "Tussock",
   "Tutu",
   "Twilight",
   "Twilight Blue",
   "Twilight Lavender",
   "Twine",
   "Tyrian Purple",
   "UA Blue",
   "UA Red",
   "UCLA Blue",
   "UCLA Gold",
   "UFO Green",
   "UP Forest Green",
   "UP Maroon",
   "USAFA Blue",
   "Ube",
   "Ultra Pink",
   "Ultramarine",
   "Ultramarine Blue",
   "Umber",
   "Unbleached Silk",
   "Underage Pink",
   "United Nations Blue",
   "University Of California Gold",
   "University Of Tennessee Orange",
   "Unmellow Yellow",
   "Upsdell Red",
   "Urobilin",
   "Utah Crimson",
   "Valencia",
   "Valentino",
   "Valhalla",
   "Van Cleef",
   "Van Dyke Brown",
   "Vanilla",
   "Vanilla Ice",
   "Varden",
   "Vegas Gold",
   "Venetian Red",
   "Venice Blue",
   "Venus",
   "Verdigris",
   "Verdun Green",
   "Vermilion",
   "Veronica",
   "Very Light Azure",
   "Very Light Blue",
   "Very Light Malachite Green",
   "Very Light Tangelo",
   "Very Pale Orange",
   "Very Pale Yellow",
   "Vesuvius",
   "Victoria",
   "Vida Loca",
   "Viking",
   "Vin Rouge",
   "Viola",
   "Violent Violet",
   "Violet",
   "Violet Blue",
   "Violet Eggplant",
   "Violet Red",
   "Viridian",
   "Viridian Green",
   "Vis Vis",
   "Vista Blue",
   "Vista White",
   "Vivid Amber",
   "Vivid Auburn",
   "Vivid Burgundy",
   "Vivid Cerise",
   "Vivid Cerulean",
   "Vivid Crimson",
   "Vivid Gamboge",
   "Vivid Lime Green",
   "Vivid Malachite",
   "Vivid Mulberry",
   "Vivid Orange",
   "Vivid Orange Peel",
   "Vivid Orchid",
   "Vivid Raspberry",
   "Vivid Red",
   "Vivid Red Tangelo",
   "Vivid Sky Blue",
   "Vivid Tangelo",
   "Vivid Tangerine",
   "Vivid Vermilion",
   "Vivid Violet",
   "Vivid Yellow",
   "Volt",
   "Voodoo",
   "Vulcan",
   "Wafer",
   "Waikawa Gray",
   "Waiouru",
   "Walnut",
   "Warm Black",
   "Wasabi",
   "Water Leaf",
   "Watercourse",
   "Waterloo ",
   "Waterspout",
   "Wattle",
   "Watusi",
   "Wax Flower",
   "We Peep",
   "Web Chartreuse",
   "Web Orange",
   "Wedgewood",
   "Weldon Blue",
   "Well Read",
   "Wenge",
   "West Coast",
   "West Side",
   "Westar",
   "Wewak",
   "Wheat",
   "Wheatfield",
   "Whiskey",
   "Whisper",
   "White",
   "White Ice",
   "White Lilac",
   "White Linen",
   "White Pointer",
   "White Rock",
   "White Smoke",
   "Wild Blue Yonder",
   "Wild Orchid",
   "Wild Rice",
   "Wild Sand",
   "Wild Strawberry",
   "Wild Watermelon",
   "Wild Willow",
   "William",
   "Willow Brook",
   "Willow Grove",
   "Willpower Orange",
   "Windsor",
   "Windsor Tan",
   "Wine",
   "Wine Berry",
   "Wine Dregs",
   "Winter Hazel",
   "Winter Sky",
   "Winter Wizard",
   "Wintergreen Dream",
   "Wisp Pink",
   "Wisteria",
   "Wistful",
   "Witch Haze",
   "Wood Bark",
   "Woodland",
   "Woodrush",
   "Woodsmoke",
   "Woody Brown",
   "X11 Dark Green",
   "X11 Gray",
   "Xanadu",
   "Yale Blue",
   "Yankees Blue",
   "Yellow",
   "Yellow Green",
   "Yellow Metal",
   "Yellow Orange",
   "Yellow Rose",
   "Yellow Sea",
   "Your Pink",
   "Yukon Gold",
   "Yuma",
   "Zaffre",
   "Zambezi",
   "Zanah",
   "Zest",
   "Zeus",
   "Ziggurat",
   "Zinnwaldite",
   "Zinnwaldite Brown",
   "Zircon",
   "Zombie",
   "Zomp",
   "Zorba",
   "Zuccini",
   "Zumthor"
];